import type { TutorSlotLogStore } from './interfaces'

export const actions = {
  setLoading (this: TutorSlotLogStore, payload: TutorSlotLogStore['loading']): void {
    this.loading = payload
  },
  setFilterTutorId (this: TutorSlotLogStore, payload: TutorSlotLogStore['filterTutorId']): void {
    this.filterTutorId = payload
  },
  setFilterDate (this: TutorSlotLogStore, payload: TutorSlotLogStore['filterDate']): void {
    this.filterDate = payload
  },
  setFilterSlotTime (this: TutorSlotLogStore, payload: TutorSlotLogStore['filterSlotTime']): void {
    this.filterSlotTime = payload
  },
  setSelectedTutorOption (this: TutorSlotLogStore, payload: TutorSlotLogStore['selectedTutorOption']): void {
    this.selectedTutorOption = payload
  },
  setLogsPaginatedData (this: TutorSlotLogStore, payload: TutorSlotLogStore['logsPaginatedData']): void {
    this.logsPaginatedData = payload
  },
  setHasSearched (this: TutorSlotLogStore, payload: TutorSlotLogStore['hasSearched']): void {
    this.hasSearched = payload
  },
  resetFilters (this: TutorSlotLogStore): void {
    this.filterTutorId = null
    this.filterDate = null
    this.filterSlotTime = null
    this.selectedTutorOption = null
    this.logsPaginatedData = null
    this.hasSearched = false
    this.loading = false
  },
}
